/** Default social URLs — used when Firestore has no value yet. */
export const DEFAULT_SOCIAL_LINKS = {
  youtube: "https://www.youtube.com/@AneenHumanRights",
  x: "https://x.com/AneenHumanRight",
  tiktok: "https://www.tiktok.com/@aneenhumanrights",
  facebook: "https://www.facebook.com/AneenHumanRights",
  linkedin: "https://www.linkedin.com/in/aneenhumanrights/",
  instagram: "https://www.instagram.com/aneenhumanrights/",
  telegram: "https://t.me/aneenapp",
  whatsapp: "https://chat.whatsapp.com/Gsks6sZQIelBDsXqQ92PdA",
};

export const SOCIAL_LINK_FIELDS = [
  { key: "youtube", label: "YouTube" },
  { key: "x", label: "X (Twitter)" },
  { key: "tiktok", label: "TikTok" },
  { key: "facebook", label: "Facebook" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "instagram", label: "Instagram" },
  { key: "telegram", label: "Telegram" },
  { key: "whatsapp", label: "WhatsApp" },
];

export function mergeSocialLinks(fromFirestore) {
  // First time (no social_links saved) → prefill defaults in the form.
  if (!fromFirestore || typeof fromFirestore !== "object") {
    return { ...DEFAULT_SOCIAL_LINKS };
  }

  // Saved config → keep empty strings so admin can hide icons.
  const out = {};
  for (const field of SOCIAL_LINK_FIELDS) {
    if (Object.prototype.hasOwnProperty.call(fromFirestore, field.key)) {
      out[field.key] = fromFirestore[field.key] == null ? "" : String(fromFirestore[field.key]);
    } else {
      out[field.key] = DEFAULT_SOCIAL_LINKS[field.key];
    }
  }
  return out;
}
